import { Payroll, PayrollImport } from "types/Models/payroll";
import { emptyApi } from "./emptyApi";
import { Pagination } from "types/Models/pagination";
import qs from "qs";

type AddPayrollPayload = {
  transactions: {
    description: string;
    amount: number;
    merchant_data_id?: string | null;
    accrual_category_id: string | null;
    invoice_id?: string | null;
  }[];
  ledger_entry_name: string;
  transaction_date: string;
  is_recurring_enabled: boolean;
  frequency?: string;
  end_date?: string;
  max_recurring_count?: number;
  ledger_type: string;
  other_ledger_type_str?: string;
  payroll_period_start_date: string;
  payroll_period_end_date: string;
  pay_day_date: string;
  gross_pay: number;
  total_employee_taxes: number;
  total_employer_taxes: number;
  reimbursement: number;
  deductions: number;
  file_id: string;
};

type PayrollResponse = {
  payrolls: Payroll[];
} & Pagination;

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getAllPayrolls: build.query<
      PayrollResponse,
      {
        entityId: string;
        page_num: number;
        search_term: string | null;
      }
    >({
      query: ({ entityId, page_num, search_term }) => {
        let queryUrl = qs.stringify(
          {
            page_num,
            search_term,
          },
          { addQueryPrefix: true, skipNulls: true }
        );
        return {
          method: "GET",
          url: `/api/inkle/bookkeeping/entity/${entityId}/payroll/${queryUrl}`,
        };
      },
      providesTags: ["PAYROLL"],
    }),

    importPayroll: build.mutation<
      PayrollImport,
      {
        entityId: string;
        file: File;
      }
    >({
      query: ({ entityId, file }) => {
        const formData = new FormData();
        formData.append("csv", file);
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/payroll-import/`,
          method: "POST",
          body: formData,
        };
      },
    }),

    addPayroll: build.mutation<
      PayrollImport,
      {
        entityId: string;
        payload: AddPayrollPayload;
      }
    >({
      query: ({ entityId, payload }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/payroll/`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["PAYROLL", "JOURNAL_ENTRIES"],
    }),

    getPayroll: build.query<
      Payroll,
      {
        entityId: string;
        payrollId: string;
      }
    >({
      query: ({ entityId, payrollId }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/payroll/${payrollId}/`,
        };
      },
      providesTags: ["PAYROLL", "JOURNAL_ENTRIES"],
    }),

    deletePayroll: build.mutation<
      PayrollImport,
      {
        entityId: string;
        payrollId: string;
      }
    >({
      query: ({ entityId, payrollId }) => {
        return {
          url: `/api/inkle/bookkeeping/entity/${entityId}/payroll/${payrollId}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["PAYROLL", "JOURNAL_ENTRIES"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useImportPayrollMutation,
  useAddPayrollMutation,
  useGetAllPayrollsQuery,
  useGetPayrollQuery,
  useDeletePayrollMutation,
} = extendedApi;
